export enum AssetOperationType {
    New = 1,
    Overridden = 2,
    Ignored = 3,
    Retained = 4
}
